var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"cursor-pointer mb-2 mr-2",attrs:{"icon":"MessageCircleIcon","badge":_vm._f("persian_digits")(_vm.unreadChats ? _vm.unreadChats : '')},on:{"click":function($event){return _vm.$router.push({ name: 'chat' })}}})}
var staticRenderFns = []

export { render, staticRenderFns }